import { render } from "./ProjectBoardPageTasks.vue?vue&type=template&id=569270ce&ts=true"
import script from "./ProjectBoardPageTasks.vue?vue&type=script&lang=ts"
export * from "./ProjectBoardPageTasks.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__